import React, { useCallback, useRef, useState } from 'react';
import { Transition } from '@headlessui/react';
import classNames from 'classnames';
import { ChevronUp, ChevronDown } from '@untitled-ui/icons-react';
export function Collapsible(_a) {
    var children = _a.children, open = _a.open, setOpen = _a.setOpen, title = _a.title, className = _a.className, hideButtonLabel = _a.hideButtonLabel;
    var _b = useState(), height = _b[0], setHeight = _b[1];
    var ref = useRef(null);
    var calculateHeight = useCallback(function () {
        var _a, _b;
        if ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) {
            setHeight((_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.clientHeight);
        }
    }, []);
    var scrollIntoView = useCallback(function () {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
    }, []);
    var setRef = useCallback(function (div) {
        if (div !== ref.current) {
            ref.current = div;
        }
        if (div) {
            setHeight(div.clientHeight);
        }
    }, []);
    var Icon = open ? ChevronUp : ChevronDown;
    return (React.createElement("div", { className: classNames("p-3", className), style: { "--collapsible-height": height && "".concat(height, "px") } },
        React.createElement("button", { onClick: function () { return setOpen(!open); }, className: "w-full text-left font-semibold text-gray-700 flex flex-row justify-between items-start gap-4" },
            title,
            React.createElement("span", { className: 'text-sm text-gray-600 flex-none flex items-center' },
                !hideButtonLabel &&
                    React.createElement("span", { className: 'relative' },
                        React.createElement("span", { className: classNames('absolute block w-full text-right', { 'invisible': !open }) }, "Hide"),
                        React.createElement("span", { className: classNames('block', { 'invisible': open }) }, "Show")),
                React.createElement(Icon, { className: 'size-6 text-gray-400' }))),
        React.createElement(Transition, { beforeEnter: calculateHeight, beforeLeave: calculateHeight, afterEnter: scrollIntoView, show: open, enter: "duration-200 ease-out", enterFrom: "opacity-0 -translate-y-2 h-0", enterTo: "opacity-100 translate-y-0 h-collapsible", leave: "duration-300 ease-out", leaveFrom: "opacity-100 translate-y-0 h-collapsible", leaveTo: "opacity-0 -translate-y-2 h-0" },
            React.createElement("div", { className: "origin-top transition-all" },
                React.createElement("div", { className: 'pt-5', ref: setRef }, children)))));
}
